(function ($) {
	'use strict';

	$(function () {
		const token = $('meta[name="csrf-token"]').attr('content');
		let undoTimer = null;
		let lastRemoved = null;
		let lastApplyTrigger = null;
		let applyPayload = null;
		const confirmErrorMessage = window.___('Підтвердіть актуальність даних, щоб надіслати відгук.');

		function toast(message, actionLabel, actionCallback) {
			let $toast = $('[data-saved-vacancy-toast]');
			if (!$toast.length) {
				$toast = $('<div class="saved-vacancy-toast" data-saved-vacancy-toast></div>').appendTo('body');
			}

			$toast.empty().append($('<span></span>').text(message));
			if (actionLabel && actionCallback) {
				$('<button type="button"></button>')
					.text(actionLabel)
					.on('click', actionCallback)
					.appendTo($toast);
			}

			$toast.addClass('is-visible');
			clearTimeout(undoTimer);
			undoTimer = setTimeout(function () {
				$toast.removeClass('is-visible');
				lastRemoved = null;
			}, 5200);
		}

		function showLoginModal(loginUrl) {
			let $modal = $('[data-save-login-modal]');
			if (!$modal.length) {
				$modal = $(
					'<div class="saved-vacancy-login-modal" data-save-login-modal>' +
						'<div class="saved-vacancy-login-modal__dialog">' +
							window.___('<button type="button" class="saved-vacancy-login-modal__close" aria-label="Закрити"><i class="uil uil-times"></i></button>') +
							'<div class="saved-vacancy-login-modal__icon"><i class="uil uil-bookmark"></i></div>' +
							window.___('<h3>Збереження вакансії</h3>') +
							window.___('<p>Увійдіть або зареєструйтесь, щоб зберігати вакансії.</p>') +
							'<div class="saved-vacancy-login-modal__actions">' +
								window.___('<a href="#" data-save-login-link class="btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 text-white rounded-md">Увійти</a>') +
								window.___('<a href="/signup" class="btn border border-slate-200 dark:border-slate-700 hover:border-emerald-600 hover:text-emerald-600 rounded-md">Зареєструватися</a>') +
							'</div>' +
						'</div>' +
					'</div>'
				).appendTo('body');
			}

			$modal.find('[data-save-login-link]').attr('href', loginUrl);
			$modal.addClass('is-open');
		}

		function escapeHtml(value) {
			return String(value || '').replace(/[&<>"']/g, function (char) {
				return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'}[char];
			});
		}

		function applyModal() {
			let $modal = $('[data-apply-modal]');
			if (!$modal.length) {
				$modal = $(
					'<div class="apply-vacancy-modal" data-apply-modal role="dialog" aria-modal="true" aria-labelledby="apply-vacancy-title">' +
						'<div class="apply-vacancy-modal__dialog">' +
							'<div class="apply-vacancy-modal__header">' +
								window.___('<div><h3 id="apply-vacancy-title">Відгукнутися на вакансію</h3><p data-apply-subtitle>Оберіть резюме та, за бажанням, додайте коротке повідомлення роботодавцю.</p></div>') +
								window.___('<button type="button" class="apply-vacancy-modal__close" data-apply-close aria-label="Закрити"><i class="uil uil-times"></i></button>') +
							'</div>' +
							'<div class="apply-vacancy-modal__body" data-apply-body></div>' +
							'<div class="apply-vacancy-modal__footer" data-apply-footer></div>' +
						'</div>' +
					'</div>'
				).appendTo('body');
			}

			return $modal;
		}

		function nextFrame(callback) {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(function () {
					window.requestAnimationFrame(callback);
				});
			} else {
				setTimeout(callback, 20);
			}
		}

		function openApplyModal() {
			const $modal = applyModal();
			$('body').addClass('apply-vacancy-modal-open');
			$modal.removeClass('is-closing is-open');
			nextFrame(function () {
				$modal.addClass('is-open');
			});
			setTimeout(function () {
				$modal.find('button, a, input, textarea').filter(':visible').first().trigger('focus');
			}, 260);
		}

		function closeApplyModal() {
			const $modal = applyModal();
			$modal.removeClass('is-open');
			$('body').removeClass('apply-vacancy-modal-open');
			if (lastApplyTrigger) $(lastApplyTrigger).trigger('focus');
		}

		function modalMessage(title, text, actions) {
			const $modal = applyModal();
			$modal.find('#apply-vacancy-title').text(title);
			$modal.find('[data-apply-subtitle]').text(text || '');
			$modal.find('[data-apply-body]').html('');
			const $footer = $modal.find('[data-apply-footer]').empty();

			(actions || [{label: window.___('Закрити'), className: 'btn border border-slate-200 dark:border-slate-700 rounded-md', click: closeApplyModal}]).forEach(function (action) {
				const $button = action.href
					? $('<a></a>').attr('href', action.href)
					: $('<button type="button"></button>').on('click', action.click || closeApplyModal);
				$button.addClass(action.className || 'btn border border-slate-200 dark:border-slate-700 rounded-md').text(action.label).appendTo($footer);
			});

			openApplyModal();
		}

		function renderApplyForm(data, source) {
			applyPayload = data;
			const $modal = applyModal();
			const vacancy = data.vacancy;
			const autoSelected = data.selected_resume_id || (data.resumes.length === 1 ? data.resumes[0].id : null);

			$modal.find('#apply-vacancy-title').text(window.___('Відгукнутися на вакансію'));
			$modal.find('[data-apply-subtitle]').text(window.___('Оберіть резюме та, за бажанням, додайте коротке повідомлення роботодавцю.'));

			const vacancyMeta = [vacancy.city, vacancy.work_format, vacancy.employment_type].filter(Boolean).join(' · ');
			const resumesHtml = data.resumes.map(function (resume) {
				const checked = String(autoSelected || data.resumes[0].id) === String(resume.id) ? ' checked' : '';
				const hiddenWarning = resume.active ? '' : window.___('<div class="apply-resume-warning">Це резюме приховане в пошуку, але ви можете надіслати його роботодавцю у відгуку.</div>');
				return '<label class="apply-resume-card">' +
					'<input type="radio" name="resume_id" value="' + resume.id + '"' + checked + '>' +
					'<span class="apply-resume-card__content">' +
						'<strong>' + escapeHtml(resume.title) + '</strong>' +
						(resume.roles ? '<small>' + escapeHtml(resume.roles) + '</small>' : '') +
						'<em>' + escapeHtml([resume.cities, resume.salary].filter(Boolean).join(' · ')) + '</em>' +
						'<b>' + escapeHtml(resume.status) + (resume.updated ? window.___(' · Оновлено ') + escapeHtml(resume.updated) : '') + (autoSelected === resume.id ? window.___(' · Обрано автоматично') : '') + '</b>' +
						hiddenWarning +
					'</span>' +
				'</label>';
			}).join('');

			const phoneWarning = data.contact.phone_missing
				? window.___('<div class="apply-contact-warning">У профілі не вказано телефон. Додайте номер, щоб роботодавець міг швидше зв’язатися з вами.</div>')
				: '';

			$modal.find('[data-apply-body]').html(
				'<form data-apply-form data-apply-url="' + escapeHtml(data.apply_url) + '" data-source="' + escapeHtml(source || 'site') + '" data-offer-id="' + escapeHtml(data.offer_id || '') + '">' +
					'<div class="apply-vacancy-card">' +
						'<h4>' + escapeHtml(vacancy.title) + '</h4>' +
						'<strong>' + escapeHtml(vacancy.company) + '</strong>' +
						(vacancyMeta ? '<p>' + escapeHtml(vacancyMeta) + '</p>' : '') +
						'<span>' + escapeHtml(vacancy.salary || window.___('Зарплата не вказана')) + '</span>' +
					'</div>' +
					'<section class="apply-modal-section">' +
						window.___('<div class="apply-modal-section__head"><h4>Оберіть резюме</h4><p>Роботодавець отримає вибране резюме разом із вашим відгуком.</p></div>') +
						'<div class="apply-resume-list">' + resumesHtml + '</div>' +
						'<a href="' + escapeHtml(data.create_resume_url) + window.___('" class="apply-modal-link">Створити нове резюме</a>') +
					'</section>' +
					'<section class="apply-modal-section">' +
						window.___('<label class="apply-field"><span>Повідомлення роботодавцю</span><textarea name="message" maxlength="1000" placeholder="Напишіть коротко, чому вас зацікавила ця вакансія або чому ви підходите на цю роль"></textarea></label>') +
						window.___('<div class="apply-field-help">Необов’язково, але коротке повідомлення може допомогти роботодавцю швидше зрозуміти вашу мотивацію. <b data-message-count>0 / 1000</b></div>') +
						window.___('<div class="apply-field-error" data-message-error>Повідомлення не може бути довшим за 1000 символів.</div>') +
					'</section>' +
					'<section class="apply-modal-section">' +
						window.___('<div class="apply-modal-section__head"><h4>Контактні дані</h4><p>Роботодавець зможе побачити ваші контакти після отримання відгуку.</p></div>') +
						'<div class="apply-contact-grid">' +
							'<span><i class="uil uil-user"></i>' + escapeHtml(data.contact.name) + '</span>' +
							'<span><i class="uil uil-envelope"></i>' + escapeHtml(data.contact.email) + '</span>' +
							'<span><i class="uil uil-phone"></i>' + escapeHtml(data.contact.phone || window.___('Телефон не вказано')) + '</span>' +
							'<span><i class="uil uil-map-marker"></i>' + escapeHtml(data.contact.city || window.___('Місто не вказано')) + '</span>' +
						'</div>' +
						phoneWarning +
						'<a href="' + escapeHtml(data.profile_url) + window.___('" class="apply-modal-link">Редагувати особисті дані</a>') +
					'</section>' +
					window.___('<label class="apply-confirm" data-apply-confirm><input type="checkbox" name="confirm_actual" value="1"><span>Підтверджую, що вибране резюме та контактні дані актуальні.</span></label>') +
					'<div class="apply-field-error" data-apply-error></div>' +
				'</form>'
			);

			$modal.find('[data-apply-footer]').html(
				window.___('<button type="button" class="btn border border-slate-200 dark:border-slate-700 hover:border-emerald-600 hover:text-emerald-600 rounded-md" data-apply-cancel>Скасувати</button>') +
				window.___('<button type="button" class="btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 text-white rounded-md" data-apply-submit disabled>Надіслати відгук</button>')
			);

			openApplyModal();
			refreshApplySubmit();
		}

		function refreshApplySubmit() {
			const $form = $('[data-apply-form]');
			if (!$form.length) return;
			const hasResume = !!$form.find('input[name="resume_id"]:checked').length;
			const validMessage = ($form.find('textarea[name="message"]').val() || '').length <= 1000;
			$('[data-apply-submit]').prop('disabled', !(hasResume && validMessage));
		}

		function clearConfirmError() {
			$('[data-apply-confirm]').removeClass('is-error');
			$('[data-apply-error]').removeClass('is-visible').text('');
		}

		function showConfirmError() {
			const $confirm = $('[data-apply-confirm]');
			const $body = $('[data-apply-body]');
			$confirm.addClass('is-error');
			$('[data-apply-error]').text(confirmErrorMessage).addClass('is-visible');

			if ($body.length && $confirm.length) {
				$body.stop().animate({
					scrollTop: $body.scrollTop() + $confirm.position().top - 16
				}, 420, 'swing');
			}

			const input = $confirm.find('input[name="confirm_actual"]')[0];
			if (input && input.focus) {
				try {
					input.focus({preventScroll: true});
				} catch (error) {
					$(input).trigger('focus');
				}
			}
		}

		function renderApplySuccess(response) {
			const vacancy = applyPayload ? applyPayload.vacancy : null;
			const application = response.application || {};
			const $modal = applyModal();

			$modal.find('#apply-vacancy-title').text(window.___('Відгук надіслано'));
			$modal.find('[data-apply-subtitle]').text(window.___('Ваш відгук передано роботодавцю. Статус можна відстежувати в історії відгуків.'));
			$modal.find('[data-apply-body]').html(
				'<div class="apply-success-card">' +
					'<div class="apply-success-card__icon"><i class="uil uil-check-circle"></i></div>' +
					(vacancy ? '<h4>' + escapeHtml(vacancy.title) + '</h4>' : '') +
					(application.resume_title ? window.___('<p>Резюме: ') + escapeHtml(application.resume_title) + '</p>' : '') +
					(application.created_at ? window.___('<p>Дата відгуку: ') + escapeHtml(application.created_at) + '</p>' : '') +
				'</div>'
			);
			$modal.find('[data-apply-footer]').html(
				'<a href="' + escapeHtml(application.history_url || '/profile/applications') + window.___('" class="btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 text-white rounded-md">Перейти до історії відгуків</a>') +
				(vacancy ? '<a href="' + escapeHtml(vacancy.url) + window.___('" class="btn border border-slate-200 dark:border-slate-700 hover:border-emerald-600 hover:text-emerald-600 rounded-md">Переглянути вакансію</a>') : '') +
				window.___('<button type="button" class="btn border border-slate-200 dark:border-slate-700 rounded-md" data-apply-close>Закрити</button>')
			);
		}

		function markApplied(jobId) {
			$('[data-jobs-apply-button][data-job-id="' + jobId + '"], .js-apply-vacancy[data-job-id="' + jobId + '"]').each(function () {
				$(this)
					.addClass('is-applied')
					.removeAttr('data-apply-url')
					.html(window.___('<i class="uil uil-check-circle"></i> Ви вже відгукнулися'));
			});
			$('[data-jobs-apply-message]').text(window.___('Роботодавець отримав ваш відгук.'));
		}

		function updateButton($button, isSaved) {
			$button.toggleClass('is-saved', isSaved)
				.attr('data-saved', isSaved ? '1' : '0')
				.attr('aria-label', isSaved ? window.___('Видалити вакансію зі збережених') : window.___('Зберегти вакансію'));
			$button.find('span').text(isSaved ? window.___('Збережено') : ($button.closest('.job-card').length ? window.___('Зберегти') : window.___('Зберегти вакансію')));
		}

		function setLoading($button, isLoading) {
			$button.prop('disabled', isLoading).toggleClass('is-loading', isLoading);
			if (isLoading) {
				$button.data('previous-text', $button.find('span').text());
				$button.find('span').text(window.___('Збереження...'));
			} else if ($button.data('previous-text')) {
				$button.find('span').text($button.data('previous-text'));
				$button.removeData('previous-text');
			}
		}

		$(document).on('click', '.js-save-vacancy-login', function (event) {
			event.preventDefault();
			showLoginModal($(this).data('login-url') || $(this).attr('href'));
		});

		$(document).on('click', '[data-save-login-modal]', function (event) {
			if (event.target === this) $(this).removeClass('is-open');
		});

		$(document).on('click', '.saved-vacancy-login-modal__close', function () {
			$('[data-save-login-modal]').removeClass('is-open');
		});

		$(document).on('keydown', function (event) {
			if (event.key === 'Escape') $('[data-save-login-modal]').removeClass('is-open');
		});

		$(document).on('click', '.js-apply-vacancy', function (event) {
			event.preventDefault();
			const $button = $(this);
			const modalUrl = $button.data('modal-url');
			if (!modalUrl) return;

			lastApplyTrigger = this;
			$button.addClass('is-loading');

			$.ajax({
				url: modalUrl,
				method: 'GET',
				dataType: 'json',
				headers: {'Accept': 'application/json'}
			}).done(function (response) {
				if (response.state === 'auth_required') {
					modalMessage(window.___('Увійдіть, щоб відгукнутися'), window.___('Щоб надіслати відгук роботодавцю, увійдіть у профіль шукача або створіть акаунт.'), [
						{label: window.___('Увійти'), href: response.login_url, className: 'btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 text-white rounded-md'},
						{label: window.___('Зареєструватися'), href: response.registration_url, className: 'btn border border-slate-200 dark:border-slate-700 hover:border-emerald-600 hover:text-emerald-600 rounded-md'},
						{label: window.___('Закрити'), className: 'btn border border-slate-200 dark:border-slate-700 rounded-md', click: closeApplyModal}
					]);
				} else if (response.state === 'employer_forbidden') {
					modalMessage(window.___('Отклик доступний тільки шукачам'), window.___('Щоб відгукнутися на вакансію, потрібно увійти як шукач.'));
				} else if (response.state === 'already_applied') {
					modalMessage(window.___('Відгук уже надіслано'), window.___('Ви вже відгукнулися на цю вакансію. Переглянути статус можна в історії відгуків.'), [
						{label: window.___('Перейти до історії відгуків'), href: response.history_url, className: 'btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 text-white rounded-md'},
						{label: window.___('Закрити'), className: 'btn border border-slate-200 dark:border-slate-700 rounded-md', click: closeApplyModal}
					]);
				} else if (response.state === 'no_resumes') {
					modalMessage(window.___('Створіть резюме, щоб відгукнутися'), window.___('Роботодавець отримає ваш відгук разом із резюме. Створіть резюме, щоб продовжити.'), [
						{label: window.___('Створити резюме'), href: response.create_resume_url, className: 'btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 text-white rounded-md'},
						{label: window.___('Закрити'), className: 'btn border border-slate-200 dark:border-slate-700 rounded-md', click: closeApplyModal}
					]);
				} else if (response.state === 'unavailable') {
					modalMessage(window.___('Вакансія недоступна'), window.___('Роботодавець більше не приймає відгуки на цю вакансію.'));
				} else if (response.state === 'ready') {
					renderApplyForm(response, $button.data('source') || 'site');
				}
			}).fail(function () {
				toast(window.___('Не вдалося надіслати відгук. Спробуйте ще раз.'));
			}).always(function () {
				$button.removeClass('is-loading');
			});
		});

		$(document).on('click', '[data-apply-close], [data-apply-cancel]', closeApplyModal);

		$(document).on('click', '[data-apply-modal]', function (event) {
			if (event.target === this) closeApplyModal();
		});

		$(document).on('keydown', function (event) {
			if (event.key === 'Escape' && $('[data-apply-modal]').hasClass('is-open')) closeApplyModal();
		});

		$(document).on('change', '[data-apply-form] input[name="resume_id"], [data-apply-form] input[name="confirm_actual"]', function () {
			if ($(this).attr('name') === 'confirm_actual' && $(this).is(':checked')) clearConfirmError();
			refreshApplySubmit();
		});

		$(document).on('input', '[data-apply-form] textarea[name="message"]', function () {
			const length = ($(this).val() || '').length;
			$('[data-message-count]').text(length + ' / 1000');
			$('[data-message-error]').toggleClass('is-visible', length > 1000);
			refreshApplySubmit();
		});

		$(document).on('click', '[data-apply-submit]', function () {
			const $button = $(this);
			const $form = $('[data-apply-form]');
			const jobId = lastApplyTrigger ? $(lastApplyTrigger).data('job-id') : null;
			const messageLength = ($form.find('textarea[name="message"]').val() || '').length;

			if (!$form.find('input[name="confirm_actual"]').is(':checked')) {
				showConfirmError();
				return;
			}
			if (messageLength > 1000) return;

			clearConfirmError();
			$button.prop('disabled', true).text(window.___('Надсилаємо...'));

			$.ajax({
				url: $form.data('apply-url'),
				method: 'POST',
				dataType: 'json',
				headers: {
					'X-CSRF-TOKEN': token,
					'Accept': 'application/json'
				},
				data: {
					resume_id: $form.find('input[name="resume_id"]:checked').val(),
					message: $form.find('textarea[name="message"]').val(),
					confirm_actual: $form.find('input[name="confirm_actual"]').is(':checked') ? 1 : 0,
					source: $form.data('source') || 'site',
					offer_id: $form.data('offer-id') || ''
				}
			}).done(function (response) {
				if (jobId) markApplied(jobId);
				$(document).trigger('candidate:application-sent', [response, jobId, $form.data('offer-id') || response.offer_id || null]);
				renderApplySuccess(response);
			}).fail(function (xhr) {
				let message = window.___('Не вдалося надіслати відгук. Спробуйте ще раз.');
				if (xhr.status === 404) message = window.___('Ця вакансія більше недоступна.');
				if (xhr.status === 401) message = window.___('Сесія завершилася. Увійдіть ще раз, щоб продовжити.');
				if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.errors) {
					message = Object.values(xhr.responseJSON.errors)[0][0] || message;
				}
				$('[data-apply-error]').text(message).addClass('is-visible');
				$button.prop('disabled', false).text(window.___('Надіслати відгук'));
			});
		});

		$(document).on('click', '.js-save-vacancy', function () {
			const $button = $(this);
			if ($button.prop('disabled')) return;

			const wasSaved = String($button.attr('data-saved')) === '1';
			const url = wasSaved ? $button.data('unsave-url') : $button.data('save-url');

			setLoading($button, true);

			$.ajax({
				url: url,
				method: wasSaved ? 'DELETE' : 'POST',
				dataType: 'json',
				headers: {
					'X-CSRF-TOKEN': token,
					'Accept': 'application/json'
				}
			}).done(function (response) {
				setLoading($button, false);
				updateButton($button, !!response.saved);
				toast(response.message || (response.saved ? window.___('Вакансію додано до збережених.') : window.___('Вакансію видалено зі збережених.')));
			}).fail(function () {
				setLoading($button, false);
				updateButton($button, wasSaved);
				toast(window.___('Не вдалося зберегти вакансію. Спробуйте ще раз.'));
			});
		});

		$(document).on('click', '.js-remove-saved-vacancy', function () {
			const $button = $(this);
			const $card = $button.closest('.js-saved-vacancy-card');
			const url = $button.data('remove-url');
			if (!url || $button.prop('disabled')) return;

			$button.prop('disabled', true).addClass('is-loading');

			$.ajax({
				url: url,
				method: 'DELETE',
				dataType: 'json',
				headers: {
					'X-CSRF-TOKEN': token,
					'Accept': 'application/json'
				}
			}).done(function (response) {
				lastRemoved = {
					card: $card,
					url: $card.data('restore-url')
				};
				$card.addClass('is-removing');
				setTimeout(function () {
					$card.hide();
					if (!$('.js-saved-vacancy-card:visible').length) {
						$('[data-saved-filter-empty]').removeClass('hidden');
					}
				}, 180);

				toast(response.message || window.___('Вакансію видалено зі збережених.'), window.___('Скасувати'), function () {
					if (!lastRemoved || !lastRemoved.url) return;
					$.ajax({
						url: lastRemoved.url,
						method: 'POST',
						dataType: 'json',
						headers: {
							'X-CSRF-TOKEN': token,
							'Accept': 'application/json'
						}
					}).done(function () {
						lastRemoved.card.show().removeClass('is-removing');
						$('[data-saved-filter-empty]').addClass('hidden');
						lastRemoved = null;
						toast(window.___('Вакансію додано до збережених.'));
					});
				});
			}).fail(function () {
				$button.prop('disabled', false).removeClass('is-loading');
				toast(window.___('Не вдалося зберегти вакансію. Спробуйте ще раз.'));
			});
		});
	});
})(jQuery);
